import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Coins, MapPin } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export default function Members() {
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/members").then((r) => setMembers(r.data)).catch(() => {}); }, []);

  const initials = (n) => (n ? n.slice(0, 2).toUpperCase() : "?");

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-12">
      <h1 className="font-display text-4xl md:text-5xl text-[#1A202C]">Our Families</h1>
      <p className="text-[#4A5568] mt-2 mb-8">The hearts that make this community.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {members.map((m) => (
          <Link key={m._id} to={`/members/${m._id}`} data-testid={`member-card-${m._id}`}
            className="bg-white border border-[#6A0DAD] rounded-2xl p-6 shadow-sm hover:shadow-md transition-all">
            <div className="flex items-center gap-3">
              <Avatar className="w-12 h-12"><AvatarFallback className="bg-[#6B8EAC] text-white font-heading">{initials(m.name)}</AvatarFallback></Avatar>
              <div>
                <p className="font-heading font-semibold text-[#1A202C]">{m.name}</p>
                {m.location && <p className="text-xs text-[#4A5568] flex items-center gap-1"><MapPin size={11} /> {m.location}</p>}
              </div>
            </div>
            {m.baby_names && <p className="mt-3 text-sm text-[#6B8EAC] font-heading">Little one(s): {m.baby_names}</p>}
            {m.family_story && <p className="mt-2 text-sm text-[#4A5568] line-clamp-3 leading-relaxed">{m.family_story}</p>}
            <span className="mt-4 inline-flex items-center gap-1 text-[#B8972E] font-heading font-semibold text-sm">
              <Coins size={14} /> {m.amir_balance} AMIR
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
